export default __webpack_public_path__ + "static/background-9cbc39bfd8b1c01fb17fbb5f819b87c0.jpg";